var media = {
  smUp: "@media (min-width: 576px)",
  mdUp: "@media (min-width: 768px)",
  lgUp: "@media (min-width: 992px)",
  xlUp: "@media (min-width: 1200px)",
  smDown: "@media (max-width: 575.98px)",
  mdDown: "@media (max-width: 767.98px)",
  lgDown: "@media (max-width: 991.98px)",
  xlDown: "@media (max-width: 1199.98px)",
  xsOnly: "@media (max-width: 575.98px)",
  smOnly: "@media (min-width: 576px) and (max-width: 767.98px)",
  mdOnly: "@media (min-width: 768px) and (max-width: 991.98px)",
  lgOnly: "@media (min-width: 992px) and (max-width: 1199.98px)",
  xlOnly: "@media (min-width: 1200px)"
};

export { media as default };
